import { FC } from 'react';
import { OrderPersonInfoProps } from '../../types/props';
import { OrderPersonInfoCard } from './OrderPersonInfoCard';
import { OrderPersonInfoContent } from './OrderPersonInfoContent';
import { PenIconButton } from 'shared/ui/buttons/iconButtons/penButton';
import { useModal } from 'shared/lib/modal';
import { setSelectedPerson } from 'entities/person';
import { useAppDispatch, useAppSelector } from 'shared/lib/store';
import { selectSettingDefaultPerson } from 'entities/settings';
import { useResize } from 'app/lib/hooks/useResize';
import { PersonButton } from 'shared/ui/buttons/iconButtons/personButton';

export const OrderPersonInfo: FC<OrderPersonInfoProps> = ({ person }) => {
	const { openModal } = useModal();
	const dispatch = useAppDispatch();
	const defaultPerson = useAppSelector(selectSettingDefaultPerson);

	const openPerson = () => {
		dispatch(setSelectedPerson(person));
		openModal();
	};

  const { 
    isScreenSm
  } = useResize();

	return (
		<OrderPersonInfoCard buttons={defaultPerson === person.id||!isScreenSm ? [<PersonButton key={0} />] : [<PenIconButton onClick={openPerson} key={0} />]}>
			<OrderPersonInfoContent person={person} />
		</OrderPersonInfoCard>
	);
};
